module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_7042.9fe00731.png";